<template>
  <div class="storeCart theme-bg-gray">
    <q-list
      separator
      class="cartList"
      :class="groupByStatus.err.length === 0 ? 'pd-bt' : ''"
    >
      <div
        v-if="isDelivery"
        class="full-width-googlemap"
        @click="googlemapshow"
      >
        <GoogleMapEntrance />
      </div>
      <template v-if="cartDetailData">
        <itemCard
          v-for="item in groupByStatus.ok"
          :key="item.groupNumber"
          :product="item"
        >
          <template #pkg>
            <PkgProductItem :product="item" />
          </template>
        </itemCard>
      </template>

      <div class="addItem" @click="goProduct">+ {{ $t('cart.addItems') }}</div>
    </q-list>
    <div v-if="groupByStatus.err.length" class="error-wrap">
      <div class="errorList">
        <!-- <q-img src="~src/assets/icons/svg/icon/error-icon.svg" class="icon" /> -->
        <span class="iconfont">&#xe685;</span>
        <span>{{ $t('cart.errorGoods') }}</span>
      </div>
      <q-list v-if="cartDetailData" separator class="cartList">
        <itemCard
          v-for="(item, index) in groupByStatus.err"
          :key="index"
          :product="item"
          :is-invalid="true"
        />
      </q-list>
      <div class="align-right">
        <div class="deleteLine" @click="deleteInvalidProduct">
          <q-icon name="delete_outline" size="20px" color="gray-5" />
          {{ $t('cart.deleteErrorGoods') }}
        </div>
      </div>
    </div>

    <div
      :class="[
        'detailsBottom',
        'flex',
        'items-center',
        'theme-bg-gray',
        'justify-end',
        'q-px-md',
      ]"
    >
      <template v-if="cartDetailData">
        <div class="text-right q-mr-md">
          <div class="text-theme-gray font-size-12 q-mb-xs">
            {{ $t('cart.total') }}
          </div>
          <div v-if="totalPrice" class="text-weight-bolder font-size-16">
            {{ $n(totalPrice, 'currency', 'id-ID') }}
          </div>
          <div v-if="delPrice" class="price-del">{{ $pid(delPrice) }}</div>
        </div>
      </template>

      <q-btn
        no-caps
        unelevated
        :disable="!isCanPay || isPayLoading"
        color="primary"
        class="checkbtn border-radius-8 text-weight-bolder font-size-16"
        @click="checkUser"
      >
        <q-spinner-ios
          v-if="isPayLoading"
          color="white"
          size="0.7em"
          style="font-weight: bold; margin-right: 5px"
        />
        <div>{{ $t('cart.submit') }}</div>
      </q-btn>
    </div>
    <!-- <div class="addItem" @click="goProduct">+ Add items</div> -->
    <q-dialog v-model="errorDialog" persistent>
      <BaseDialog group="shopCart" state :reason="errorReason" />
    </q-dialog>
    <ErrDialog :show-one-type="showOneType" />

    <div v-if="isDelivery">
      <GoogleMapDialog ref="map" :list="params" @setPinpoint="setPinpiont" />
    </div>
    <i
      v-if="isFullDineIn"
      :class="['refresh', { refreshing }]"
      class="iconfont dm-reload"
      @click="refreshCart"
    />
  </div>
</template>

<script>
import {
  getCartDetailsData,
  getEmptyCart,
  clearInvalidCartItem,
} from 'src/api/cart.js';
import {
  clearInvalidCartItem as fullClearApi,
  getCart,
} from 'src/api/fullDineIn.js';
import { mapState } from 'vuex';
import ErrDialog from 'src/components/ErrorDialog.vue';
import GoogleMapDialog from 'src/components/GoogleMapDialog.vue';
import GoogleMapEntrance from 'src/components/GoogleMapEntrance.vue';
import { getTable } from 'src/utils/common';
import fullDineInMixin from 'src/pages/mixin/fullDineInMixin.js';
import {
  showDialog,
  getConfig,
  needJumoToCartConfirm,
} from 'src/utils/error_config.js';
import { resetFullDine } from 'src/utils/updateFullDineInTableData';
import { GROUP_TYPE } from 'src/utils/config';
import { getUserInfo, guestLogin } from 'src/api/login';
import axios from 'axios';
import { pushLog } from 'src/utils/pushLog';
import itemCard from './components/ItemCard.vue';
import PkgProductItem from './components/PkgProductItem.vue';
import IndexDialog from '../../components/dialog/index.vue';
import { createMeta } from './meta.js';

export default {
  components: {
    itemCard,
    ErrDialog,
    GoogleMapDialog,
    GoogleMapEntrance,
    PkgProductItem,
  },
  mixins: [fullDineInMixin],
  inject: ['reload'],
  meta() {
    return createMeta(this);
  },
  data() {
    return {
      isPayLoading: false,
      errorDialog: false,
      errorReason: '',
      showOneType: '',
      params: {
        label: '',
        name: '',
        phone: '',
        district: {},
        detail: '',
        default: false,
        subdistrict: '',
        lat: '',
        lng: '',
        districtName: '',
        subDistrictName: '',
        formatted_address: 'Please enter a location...',
      },
      refreshing: false,
    };
  },
  computed: {
    ...mapState({
      scheduled: (state) => state.Menu.scheduled,
    }),
    groupByStatus() {
      const res = {
        ok: [],
        err: [],
      };
      try {
        // 增加cartItems为空时的上报
        const cartData = this.cartDetailData || {};
        if (Object.keys(cartData).length > 0 && (!cartData.cartItems || cartData.cartItems.length === 0)) {
          pushLog({
            key: '[CART_ITEM NULL]',
            data: cartData,
          });
        }
        const items = this.cartDetailData?.cartItems || [];
        items.forEach((item, index) => {
          if (
            item.inStock &&
            item.inLive &&
            item.inList &&
            item.inService &&
            item.inSingleSale
          ) {
            res.ok.push(item);
          } else {
            res.err.push(item);
          }
        });
      } catch (error) {
        return res;
      }
      return res;
    },
    isCanPay() {
      const { err, ok } = this.groupByStatus;
      return err.length <= 0 && ok.length > 0;
    },
    totalPrice() {
      const { grandTotal, originalTotal } = this.cartDetailData;
      return originalTotal;
    },
    delPrice() {
      const { listTotal } = this.cartDetailData;
      if (listTotal !== this.totalPrice) return listTotal;
      return null;
    },
  },
  mounted() {
    if (this.isFullDineIn) {
      resetFullDine(this);
      const discounts = this._getAllDiscount();
      this.onFullDineInChange(
        'cart',
        ({ cart }, code) => {
          this.$store.dispatch('prefetch/getCartDetails', {});
          this.$nextTick(() => {
            this.$store.dispatch('prefetch/getCartDetails', cart);
          });
          if (code !== 200) {
            showDialog(this, code);
          }
        },
        { verify: false, priceDiscounts: discounts },
      );
    } else {
      this.getData();
    }
  },
  methods: {
    goProduct() {
      this.$router.push({ path: `/${this.storeUrl}/products-list` });
    },
    googlemapshow() {
      this.$refs.map.show = true;
    },
    // google map 回调事件
    setPinpiont(res) {
      this.params = {
        ...this.params,
        ...res,
      };
    },
    getData() {
      this.$store.dispatch('prefetch/getCartDetails', {});
      this.startPolling(getCartDetailsData).then((res) => {
        this.$store.dispatch('prefetch/getCartDetails', res.data);
        const { success, code } = res;
        if (![816, 817].includes(code)) return;
        if (!success) showDialog(this, res.code);
      }).catch(e => {
        window.location.reload();
      });
    },
    _getAllDiscount() {
      return this.groupByStatus?.ok.reduce((pre, cur) => {
        if (Array.isArray(cur.priceDiscount)) return [...pre, ...cur.priceDiscount];
        return [...pre];
      }, []);
    },
    async checkUser() {
      // 区分游客和用户的判断逻辑，用户需要校验手机号是否存在
      const hasUser = this.userInfo?.guestUser ? true : !!this.userInfo?.phone;
      if (!(window.localStorage.getItem('token') || this.token) || !hasUser) {
        // 1、如果开启了无注册购买，则走游客登录流程
        if (this.guestCheckout) {
          // 获取游客token
          const res = await guestLogin()
          await this.$store.dispatch('Menu/setToken', res.data);
          localStorage.setItem('token', res.data);
          // 获取游客的用户信息
          const userInfo = await getUserInfo()
          await this.$store.dispatch('Menu/setUserInfo', userInfo.data || {});
          //  跳转到结账页面
          this.goToCheckout()
        } else {
          // 2、正常用户登录流程
          await this.$store.dispatch('Menu/setToLoginPath', 'checkout');
          await this.$store.dispatch('Menu/resetUser');
          await this.$router.push({ path: `/${this.storeUrl}/login` });
        }
      } else {
        //  跳转到结账页面
        this.goToCheckout()
      }
    },
    goToCheckout() {
      // full_dine_in不支持游客登录
      if (this.isFullDineIn && this.userInfo.guestUser) {
        this.$store.dispatch('Menu/setToLoginPath', 'checkout');
        this.$store.dispatch('Menu/resetUser');
        this.$router.push({ path: `/${this.storeUrl}/login` });
        return;
      }
      // 其他模式正常跳转
      const { currentRoute } = this.$router;
      this.$store.dispatch('prefetch/prefetchStoreInfo', { currentRoute });
      const url = this.$route.params.store;
      if (
        !this.scheduled &&
        this.$store.state.prefetch.storeInfo.dineIn === true &&
        this.$store.state.prefetch.storeInfo.pickUp === false &&
        this.$store.state.Menu.accessStatus === 'PICK_UP'
      ) {
        this.showOneType = 'dineIn';
      } else if (
        !this.scheduled &&
        this.$store.state.prefetch.storeInfo.dineIn === false &&
        this.$store.state.prefetch.storeInfo.pickUp === true &&
        this.$store.state.Menu.accessStatus === 'DINE_IN'
      ) {
        this.showOneType = 'pickUp';
      } else {
        this.showOneType = '';
        this.isPayLoading = true;
        const serviceTypeVal = this.$store.state.Menu.accessStatus;

        if (!serviceTypeVal) {
          this.$router.push({ path: `/${url}` });
          return;
        }
        const tableNumber = getTable();
        const allDiscounts = this._getAllDiscount();
        const callApi = this.isFullDineIn
          ? (config = {}) => getCart.bind(null, {
            tableNumber,
            verify: true,
            priceDiscounts: allDiscounts,
            ...config
          })()
          : (config = {}) => getCartDetailsData(config);
        this.startPolling(callApi).then((res = {}) => {
          const { code, data } = res;
          if (code === 200) {
            if (res.data?.cartItems.every((item) => item.inStock)) {
              this.$store.dispatch('Menu/setToLoginPath', 'checkout');
              if (this.isFullDineIn) {
                this.$router.push({ path: `/${url}/cart_confirm` });
              } else {
                this.$router.push({ path: `/${url}/checkout` });
              }
            } else {
              this.$store.dispatch('prefetch/getCartDetails', res.data);
            }
          } else {
            const config = getConfig(this, code);
            this.$q
              .dialog({
                component: IndexDialog,
                parent: this,
                title: config.title,
                ok: config.ok,
              })
              .onOk(() => {
                if (needJumoToCartConfirm(code)) {
                  this.$router.push({
                    name: this.isFullDineIn ? 'CartConfirm' : 'checkout',
                  });
                }
              });
            this.$store.dispatch('prefetch/getCartDetails', res.data);
          }
          this.isPayLoading = false;
        }).catch(() => {
          // 取消加载效果并刷新当前页
          this.isPayLoading = false;
          window.location.reload()
        });
      }
    },
    // 多次调用接口
    async startPolling(api) {
      const source = axios.CancelToken.source()
      const MAX_REQUEST_COUNT = 3
      const TIME_OUT = 3000
      const timerList = []
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < MAX_REQUEST_COUNT; i++) {
          timerList.push(
            setTimeout(() => {
              api({ cancelToken: source.token }).then(res => {
                source.cancel()
                timerList.forEach(timer => clearTimeout(timer))
                resolve(res)
              }).catch(() => {
                source.cancel()
                timerList.forEach(timer => clearTimeout(timer))
                reject('error')
              })
            }, i * TIME_OUT)
          )
        }
      })
    },
    async deleteInvalidProduct() {
      const allApi = this.isFullDineIn ? fullClearApi : clearInvalidCartItem;
      const res = await allApi();
      this.$store.dispatch('prefetch/getCartDetails', res.data);
    },
    emptyCart() {
      getEmptyCart().then(() => {});
    },
    isPkg(type) {
      return type === GROUP_TYPE.PACKAGE;
    },
    // full dine in refresh cart manual
    refreshCart() {
      if (this.refreshing) return;
      this.refreshing = true;
      const tableNumber = getTable();
      getCart({
        tableNumber,
        verify: true,
        priceDiscounts: this._getAllDiscount(),
      })
        .then((res) => {
          this.$store.dispatch('prefetch/getCartDetails', {});
          this.$store.dispatch('prefetch/getCartDetails', res.data);
          if (res.code === 200) {
            this.$nextTick(() => {
              this.$store.dispatch('prefetch/getCartDetails', res.data);
            });
          } else {
            showDialog(this, res.code);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.refreshing = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.addItem {
  padding-top: 16px;
  padding-bottom: 16px;
  color: $primary;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}
.align-right {
  text-align: right;
  padding: 0 16px;
  background: #f3f4f5;
}
.deleteLine {
  margin-top: 16px;
  display: inline-block;
  margin-right: 0;
  color: $primary;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 120%;
}
.error-wrap {
  padding-bottom: 64px;
  .errorList {
    height: 36px;
    padding: 8px 16px;
    background: #fdf2ee;
    color: $negative;
    font-size: 12px;
    line-height: 120%;
    font-family: Montserrat;
    display: flex;
    align-items: center;
    .icon {
      width: 16px;
      height: 16px;
    }
    span {
      margin-left: 10px;
    }
  }
}

.storeCart {
  height: 100%;
  padding-top: 72px;
  .pd-bt {
    padding-bottom: 64px;
  }
}
.detailsBottom {
  height: 64px;
  position: absolute;
  width: 100%;
  bottom: 0;
  bottom: $SAFE_SIZE;
  bottom: $SAFE_SIZE1;
  .text-right {
    line-height: 120%;
  }
  .checkbtn {
    width: 160px;
    height: 40px;
    &.disabled {
      color: #ffffff !important;
    }
  }
}

.q-my-xxs {
  margin: 2px 0;
}
.disabled {
  color: #d1d5db !important;
  :deep(input),
  .q-item__label--caption {
    color: #d1d5db !important;
  }
}

.full-width-googlemap {
  width: 100%;
  height: 30px;
}

@keyframes rotating {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}

.price-del {
  font-size: 12px;
  color: $grayFont;
  text-decoration: line-through;
}
.refresh {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #000;
  z-index: 2001;
  font-size: 20px;
  animation: rotating 1s infinite linear;
  animation-play-state: paused;
  &.refreshing {
    animation-play-state: running;
  }
}
</style>
